{
  "COMPOSE_REDIRECT": {
    "OPENING": "Otvaranje novog razgovora s {email}…",
    "NO_EMAIL": "Nije navedena adresa e-pošte. Upotrijebite ?email=name@example.com",
    "CONTACT_ERROR": "Nije moguće pronaći kontakt za {email}."
  },
  "CONVERSATION": {
    "IMAGE_RESIZE": {
      "SMALL": "Mala",
      "MEDIUM": "Srednja",
      "LARGE": "Velika",
      "ORIGINAL": "Originalna"
    },
    "SHOW_HIDDEN_MESSAGES": "Prikaži skrivene poruke",
    "SELECT_A_CONVERSATION": "Odaberite razgovor u lijevom oknu",
    "CSAT_REPLY_MESSAGE": "Ocijenite razgovor",
    "404": "Nažalost, razgovor nije pronađen. Pokušajte ponovno",
    "SWITCH_VIEW_LAYOUT": "Promijeni raspored",
    "DASHBOARD_APP_TAB_MESSAGES": "Poruke",
    "UNVERIFIED_SESSION": "Identitet ovog korisnika nije potvrđen",
    "NO_MESSAGE_1": "Čini se da u vašem sandučiću nema poruka od klijenata.",
    "NO_MESSAGE_2": " da biste poslali poruku na svoju stranicu!",
    "NO_INBOX_1": "Pozdrav! Čini se da još niste dodali nijedan sandučić.",
    "NO_INBOX_2": " za početak",
    "NO_INBOX_AGENT": "Čini se da niste član nijednog sandučića. Obratite se administratoru",
    "SEARCH_MESSAGES": "Pretraži poruke u razgovorima",
    "VIEW_ORIGINAL": "Prikaži izvornik",
    "VIEW_TRANSLATED": "Prikaži prijevod",
    "TRANSLATION": "Prijevod",
    "EMPTY_STATE": {
      "CMD_BAR": "za otvaranje izbornika naredbi",
      "KEYBOARD_SHORTCUTS": "za prikaz tipkovničkih prečaca"
    },
    "SEARCH": {
      "TITLE": "Pretraži poruke",
      "RESULT_TITLE": "Rezultati pretraživanja",
      "LOADING_MESSAGE": "Obrada podataka...",
      "PLACEHOLDER": "Upišite tekst za pretraživanje poruka",
      "NO_MATCHING_RESULTS": "Nisu pronađeni rezultati."
    },
    "TRANSCRIPT": {
      "SHOW": "Prikaži cijeli transkript",
      "HIDE": "Sakrij cijeli transkript",
      "DOWNLOAD": "Preuzmi transkript",
      "COPY": "Kopiraj transkript"
    },
    "INVISIBLE_TO_CUSTOMER": "Nevidljivo klijentu",
    "SENT_VIA_EMAIL": "Poslano kontaktu i e-poštom ({time})",
    "UNREAD_MESSAGES": "Nepročitane poruke",
    "UNREAD_MESSAGE": "Nepročitana poruka",
    "CLICK_HERE": "Kliknite ovdje",
    "LOADING_INBOXES": "Učitavanje sandučića",
    "LOADING_CONVERSATIONS": "Učitavanje razgovora",
    "CANNOT_REPLY": "Ne možete odgovoriti zbog",
    "24_HOURS_WINDOW": "ograničenja 24-satnog prozora za poruke",
    "API_HOURS_WINDOW": "Možete odgovoriti na ovaj razgovor samo unutar {hours} sati",
    "FACEBOOK_CANNOT_REPLY": "Ako trebate nastaviti ovaj razgovor, ",
    "NOT_ASSIGNED_TO_YOU": "Ovaj razgovor nije dodijeljen vama. Želite li si dodijeliti ovaj razgovor?",
    "ASSIGN_TO_ME": "Dodijeli meni",
    "PENDING_WITH_BOT_BANNER": "Ovim razgovorom upravlja AI bot. Ako želite odgovoriti, prvo otvorite razgovor.",
    "INBOX_DELETE_REQUESTED_BANNER": "Ovaj sandučić je označen za brisanje, pa odgovor kupca nikada ne bi stigao. Premjestite razgovor u drugi sandučić kako biste odgovorili.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Ovaj kontakt ima još jedan otvoren razgovor #{id}",
      "MULTIPLE": "Ovaj kontakt ima još otvorenih razgovora ({count})",
      "OPEN": "Otvori",
      "SHOW": "Prikaži"
    },
    "TWILIO_WHATSAPP_CAN_REPLY": "Na ovaj razgovor možete odgovoriti samo porukom iz predloška zbog",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "ograničenja 24-satnog prozora za poruke",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Ovaj Instagram račun je migriran u novi Instagram kanal sandučić. Sve nove poruke pojavit će se tamo. Više ne možete slati poruke iz ovog razgovora.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Nije moguće poslati poruku jer korisnik nije online i e-mail kontinuitet nije dostupan.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Korisnik nije online. Možda neće primiti poruke jer e-mail kontinuitet nije dostupan.",
    "REPLYING_TO": "Odgovarate na:",
    "REMOVE_SELECTION": "Ukloni odabir",
    "DOWNLOAD": "Preuzmi",
    "OPEN_FILE": "Otvori",
    "DOWNLOAD_ATTACHMENTS": "Preuzmi sve",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Preuzmi sve privitke pojedinačno",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Preuzmi sve kao ZIP",
    "ERROR_DOWNLOADING_FILE": "Greška pri preuzimanju datoteke",
    "UNKNOWN_FILE_TYPE": "Nepoznata datoteka",
    "SAVE_CONTACT": "Spremi kontakt",
    "NO_CONTENT": "Nema sadržaja za prikaz",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Prije slanja izvršite:",
      "EXECUTE": "Izvrši",
      "RETRY": "Pokušajte ponovno",
      "CONFIRM": "Izvršiti sada?",
      "CONFIRM_YES": "Da, izvrši",
      "CONFIRM_NO": "Odustani",
      "RUNNING": "U tijeku…",
      "DONE": "Izvršeno",
      "CLAIM_DELAYED": "bit će podnesena nakon isporuke narudžbe",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Podnesena je NOVA reklamacija {reference}, {planned} je zatvorena — uredite tekst nacrta",
        "NEW_CLAIM": "Podnesena je NOVA reklamacija {reference} umjesto ažuriranja {planned} — uredite tekst nacrta",
        "OTHER_CLAIM": "Ažurirana je reklamacija {reference} umjesto {planned} — uredite tekst nacrta",
        "EXISTING_CLAIM": "Nova reklamacija nije podnesena, ažurirana je postojeća {reference} — uredite tekst nacrta",
        "OTHER": "Prošlo je drukčije nego što je nacrt pretpostavljao — uredite tekst nacrta"
      },
      "FAILED": "Nije uspjelo",
      "UNREACHABLE": "Bot nije dostupan",
      "REQUEST_FAILED": "Radnju nije bilo moguće pokrenuti, pokušajte ponovno.",
      "ACTIONS": {
        "CANCEL_ORDER": "Otkažite narudžbu",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Promijenite način plaćanja na pouzeće",
        "CREATE_CLAIM": "Podnesite reklamaciju",
        "CREATE_OR_UPDATE_CLAIM": "Podnesite ili ažurirajte reklamaciju",
        "EXTEND_ORDER_PICKUP_DATE": "Produžite rok za preuzimanje"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} je podijelio kontakt",
      "LOCATION": "{sender} je podijelio lokaciju",
      "FILE": "{sender} je podijelio datoteku"
    },
    "UPLOADING_ATTACHMENTS": "Učitavanje privitaka...",
    "REPLIED_TO_STORY": "Odgovorio je na vašu priču",
    "UNSUPPORTED_MESSAGE": "Ova poruka nije podržana. Možete je pogledati u aplikaciji Facebook / Instagram.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Ova poruka nije podržana. Možete je pogledati u aplikaciji Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Ova poruka nije podržana. Možete je pogledati u aplikaciji Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Poruka je uspješno izbrisana",
    "FAIL_DELETE_MESSSAGE": "Brisanje poruke nije uspjelo. Pokušajte ponovno",
    "NO_RESPONSE": "Nema odgovora",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Zamoli klijenta da podijeli svoj WhatsApp broj telefona",
      "PENDING_ACTION": "Zahtjev za kontaktne podatke na čekanju",
      "STATES": {
        "PENDING": "Čeka se na kontaktne podatke",
        "SHARED": "Broj telefona podijeljen",
        "IDENTITY_CONFLICT": "Broj telefona zahtijeva provjeru"
      }
    },
    "RESPONSE": "Odgovor",
    "RATING_TITLE": "Ocjena",
    "FEEDBACK_TITLE": "Povratna informacija",
    "REPLY_MESSAGE_NOT_FOUND": "Poruka nije dostupna",
    "CARD": {
      "SHOW_LABELS": "Prikaži oznake",
      "HIDE_LABELS": "Sakrij oznake"
    },
    "HEADER": {
      "MORE": "Više radnji",
      "RESOLVE_ACTION": "Riješi",
      "REOPEN_ACTION": "Ponovno otvori",
      "OPEN_ACTION": "Otvori",
      "OPEN": "Prikaži",
      "CLOSE": "Sakrij",
      "DETAILS": "detalje",
      "SNOOZED_UNTIL": "Odgođeno do",
      "SNOOZED_UNTIL_TOMORROW": "Odgođeno do sutra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odgođeno do sljedećeg tjedna",
      "SNOOZED_UNTIL_NEXT_REPLY": "Odgođeno do sljedećeg odgovora",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "propušteno",
        "DUE": "ističe"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Označi kao na čekanju",
      "SNOOZE_UNTIL": "Odgodi",
      "RESOLVE_WITHOUT_CSAT": "Riješi bez CSAT-a",
      "SNOOZE": {
        "TITLE": "Odgodi do",
        "NEXT_REPLY": "Sljedeći odgovor",
        "TOMORROW": "Sutra",
        "NEXT_WEEK": "Sljedeći tjedan"
      }
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Odgodi do",
      "APPLY": "Odgodi",
      "CANCEL": "Odustani"
    },
    "PRIORITY": {
      "TITLE": "Prioritet",
      "OPTIONS": {
        "NONE": "Nijedno",
        "URGENT": "Hitno",
        "HIGH": "Visoko",
        "MEDIUM": "Srednje",
        "LOW": "Nisko"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nijedno",
        "INPUT_PLACEHOLDER": "Odaberi prioritet",
        "NO_RESULTS": "Nisu pronađeni rezultati",
        "SUCCESSFUL": "Prioritet razgovora id {conversationId} promijenjen na {priority}",
        "FAILED": "Nije moguće promijeniti prioritet. Molim, pokušajte kasnije."
      }
    },
    "SLA": {
      "BREACHED": "prekršeno"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Otvori u novoj kartici",
      "COPY_LINK": "Kopiraj poveznicu na razgovor",
      "COPY_LINK_SUCCESS": "Poveznica na razgovor kopirana u međuspremnik",
      "PENDING": "Označi kao na čekanju",
      "RESOLVED": "Označi kao riješeno",
      "MARK_AS_UNREAD": "Označi kao nepročitano",
      "MARK_AS_READ": "Označi kao pročitano",
      "REOPEN": "Ponovno otvori razgovor",
      "SNOOZE": {
        "TITLE": "Odgodi",
        "NEXT_REPLY": "Do sljedećeg odgovora",
        "TOMORROW": "Do sutra",
        "NEXT_WEEK": "Do sljedećeg tjedna"
      },
      "ASSIGN_AGENT": "Dodijeli agenta",
      "ASSIGN_LABEL": "Dodijeli oznaku",
      "AGENTS_LOADING": "Učitavanje agenata...",
      "ASSIGN_TEAM": "Dodijeli tim",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Razgovor id {conversationId} dodijeljen je agentu \"{agentName}\"",
          "FAILED": "Nije moguće dodijeliti agenta. Pokušajte ponovno."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Oznaka #{labelName} dodijeljena je razgovoru id {conversationId}",
          "FAILED": "Nije moguće dodijeliti oznaku. Pokušajte ponovno."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Tim \"{team}\" dodijeljen je razgovoru id {conversationId}",
          "FAILED": "Nije moguće dodijeliti tim. Pokušajte ponovno."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Potpis poruke",
      "ENABLE_SIGN_TOOLTIP": "Uključi potpis",
      "DISABLE_SIGN_TOOLTIP": "Isključi potpis",
      "INSERT_SIGNATURE": "Umetni potpis u uređivač",
      "SIGNATURE_PREVIEW_IMAGE": "(potpis sa slikom)",
      "MSG_INPUT": "Shift + Enter za novi redak. Započnite s '/' za odabir unaprijed pripremljenog odgovora.",
      "PRIVATE_MSG_INPUT": "Shift + Enter za novi redak. Ovo će biti vidljivo samo agentima",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Potpis poruke nije postavljen. Postavite ga u postavkama profila.",
      "CLICK_HERE": "Kliknite ovdje za ažuriranje",
      "WHATSAPP_TEMPLATES": "Whatsapp Predlošci",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24-satni WhatsApp prozor je istekao. Odgovorite predloškom."
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Čini se da je vaš odgovor na {draftLanguage}, ali ovaj razgovor je na {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Prevedi",
      "REPLY": "Odgovori",
      "PRIVATE_NOTE": "Privatna bilješka",
      "SEND": "Pošalji",
      "SEND_EMAIL": "Pošalji e-mail",
      "SEND_SMS": "Pošalji SMS",
      "NO_SMS_INBOX": "Dodajte SMS sandučić za slanje SMS odgovora.",
      "SEND_CHAT": "Pošalji chat",
      "CREATE": "Dodaj bilješku",
      "INSERT_READ_MORE": "Pročitaj više",
      "DISMISS_REPLY": "Odbaci odgovor",
      "REPLYING_TO": "Odgovor na:",
      "REPLY_TO_THIS": "Odgovori na ovo",
      "TIP_EXPAND_ICON": "Povećaj uređivač",
      "TIP_COLLAPSE_ICON": "Smanji uređivač",
      "TIP_FORMAT_ICON": "Prikaži uređivač obogaćenog teksta",
      "HEADING_LEVEL": {
        "LABEL": "Stil teksta",
        "NORMAL": "Običan tekst",
        "H1": "Naslov 1",
        "H2": "Naslov 2",
        "H3": "Naslov 3"
      },
      "EDITOR": {
        "BOLD": "Podebljano",
        "ITALIC": "Kurziv",
        "UNDERLINE": "Podcrtano",
        "TEXT_COLOR": "Boja teksta",
        "BG_COLOR_LABEL": "Boja pozadine",
        "FONT_SIZE_LABEL": "Veličina fonta",
        "FONT_SIZE": {
          "XS": "Malo",
          "SM": "Srednje malo",
          "MD": "Zadano",
          "LG": "Veliko",
          "XL": "Vrlo veliko",
          "XXL": "Ogromno"
        },
        "CODE": "Kod",
        "LINK": "Dodaj ili ukloni poveznicu",
        "CREATE_LINK": "Izradi poveznicu",
        "SAVE_LINK": "Spremi",
        "CANCEL": "Odustani",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Poništi",
        "REDO": "Ponovi",
        "BULLET_LIST": "Popis s grafičkim oznakama",
        "ORDERED_LIST": "Numerirani popis",
        "BLOCKQUOTE": "Citat",
        "H1": "Naslov 1",
        "H2": "Naslov 2",
        "H3": "Naslov 3",
        "IMAGE_UPLOAD": "Učitaj sliku",
        "CLEAR_FORMATTING": "Očisti oblikovanje",
        "COLOR": {
          "RED": "Crvena",
          "YELLOW": "Žuta",
          "BLUE": "Plava",
          "ROSE_RED": "Ružičastocrvena",
          "DEEP_CYAN": "Tamnocijan",
          "ORANGE": "Narančasta",
          "PISTACHIO": "Pistacija",
          "PURPLE": "Ljubičasta",
          "FUCHSIA": "Fuksija",
          "SILVER": "Srebrna",
          "NAVY": "Tamnoplava",
          "OLD_PINK": "Starinska ružičasta",
          "AQUA": "Akvamarin",
          "BROWN": "Smeđa",
          "OLIVE": "Maslinasta",
          "GOLD": "Zlatna",
          "BEIGE": "Bež",
          "WINE": "Vinska",
          "FOREST": "Šumska zelena",
          "GREEN": "Zelena",
          "BLUE_GREY": "Plavosiva",
          "RUBY_RED": "Rubin crvena",
          "CHESTNUT_BROWN": "Kestenjasta",
          "ASH_GREY": "Pepeljasto siva"
        },
        "BG_COLOR": {
          "RED": "Crvena",
          "YELLOW": "Žuta",
          "BLUE": "Plava",
          "ROSE_RED": "Ružičastocrvena",
          "DEEP_CYAN": "Tamnocijan",
          "ORANGE": "Narančasta",
          "PISTACHIO": "Pistacija",
          "PURPLE": "Ljubičasta",
          "FUCHSIA": "Fuksija",
          "SILVER": "Srebrna",
          "NAVY": "Tamnoplava",
          "OLD_PINK": "Starinska ružičasta",
          "AQUA": "Akvamarin",
          "BROWN": "Smeđa",
          "OLIVE": "Maslinasta",
          "GOLD": "Zlatna",
          "BEIGE": "Bež",
          "WINE": "Vinska",
          "FOREST": "Šumska zelena",
          "GREEN": "Zelena",
          "BLUE_GREY": "Plavosiva",
          "RUBY_RED": "Rubin crvena",
          "CHESTNUT_BROWN": "Kestenjasta",
          "ASH_GREY": "Pepeljasto siva"
        }
      },
      "TIP_EMOJI_ICON": "Prikaži izbornik emojija",
      "TIP_ATTACH_ICON": "Priloži datoteke",
      "TIP_AUDIORECORDER_ICON": "Snimi zvuk",
      "TIP_AUDIORECORDER_PERMISSION": "Dopusti pristup zvuku",
      "TIP_AUDIORECORDER_ERROR": "Nije moguće otvoriti zvuk",
      "DRAG_DROP": "Povucite i ispustite ovdje za prilaganje",
      "START_AUDIO_RECORDING": "Započni snimanje zvuka",
      "STOP_AUDIO_RECORDING": "Zaustavi snimanje zvuka",
      "EMAIL_HEAD": {
        "EDIT": "Uredi",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Sakrij",
        "INCLUDE_ORIGINAL_MESSAGE": "Uključi izvornu poruku",
        "TO": "TO",
        "ADD_BCC": "Dodaj bcc",
        "EDIT_HEADERS": "Uredi",
        "HIDE_HEADER_EDITS": "Sakrij izmjene",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Unesite ispravne adrese e-pošte"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Unesite ispravne adrese e-pošte"
        },
        "SUBJECT": {
          "LABEL": "NASLOV",
          "PLACEHOLDER": "Naslov e-maila",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Nedefinirane varijable",
        "MESSAGE": "Vaša poruka sadrži nedefinirane varijable ({undefinedVariablesCount}): {undefinedVariables}. Želite li ipak poslati poruku?",
        "CONFIRM": {
          "YES": "Pošalji",
          "CANCEL": "Odustani"
        }
      },
      "COPILOT": {
        "Q": "Pitaj robota za pomoć"
      }
    },
    "VISIBLE_TO_AGENTS": "Privatna bilješka: vidljiva samo vama i vašem timu",
    "CHANGE_STATUS": "Status razgovora je promijenjen",
    "CHANGE_STATUS_FAILED": "Promjena statusa razgovora nije uspjela",
    "CHANGE_AGENT": "Dodijeljeni agent razgovora je promijenjen",
    "CHANGE_AGENT_FAILED": "Promjena dodijeljenog agenta nije uspjela",
    "ASSIGN_LABEL_SUCCESFUL": "Oznaka je uspješno dodijeljena",
    "ASSIGN_LABEL_FAILED": "Dodjela oznake nije uspjela",
    "CHANGE_TEAM": "Tim razgovora je promijenjen",
    "IMAGE_UPLOAD_ERROR": "Nije moguće učitati sliku, pokušajte ponovno",
    "FILE_SIZE_LIMIT": "Datoteka premašuje ograničenje privitka od {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "DRAFT": {
      "FILE_TOO_LARGE": "Datoteka '{fileName}' ({fileSize}) prevelika je za pohranu skice i bit će preskočena",
      "ATTACHMENT_SERIALIZATION_FAILED": "Serijalizacija privitka za pohranu skice nije uspjela",
      "STORAGE_QUOTA_EXCEEDED": "Kvota pohrane je prekoračena. Skica je spremljena bez privitaka",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Spremanje skice nije uspjelo ni bez privitaka",
      "SAVE_FAILED": "Spremanje skice razgovora nije uspjelo"
    },
    "MESSAGE_ERROR": "Nije moguće poslati ovu poruku. Pokušajte ponovno kasnije",
    "SENT_BY": "Poslao:",
    "BOT": "Bot",
    "SEND_FAILED": "Slanje poruke nije uspjelo. Pokušajte ponovno",
    "TRY_AGAIN": "pokušaj ponovno",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Odaberi agenta",
      "REMOVE": "Izbriši",
      "ASSIGN": "Dodijeli"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopiraj",
      "REPLY_TO": "Odgovori na ovu poruku",
      "DELETE": "Izbriši",
      "CREATE_A_CANNED_RESPONSE": "Dodaj u unaprijed pripremljene odgovore",
      "TRANSLATE": "Prevedi",
      "COPY_PERMALINK": "Kopiraj poveznicu na poruku",
      "LINK_COPIED": "URL poruke kopiran je u međuspremnik",
      "FORWARD": "Proslijedi",
      "FORWARD_ERROR": "Priprema proslijeđene poruke nije uspjela",
      "DELETE_CONFIRMATION": {
        "TITLE": "Jeste li sigurni da želite izbrisati ovu poruku?",
        "MESSAGE": "Ova se radnja ne može poništiti",
        "DELETE": "Izbriši",
        "CANCEL": "Odustani"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "COMMENT_TREE": {
      "TITLE": "Tema komentara",
      "EMPTY": "Nema komentara za prikaz",
      "VIEW_TREE": "Prikaži temu komentara"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Razgovor je označio kao riješen {userName}",
          "CONTACT_RESOLVED": "Razgovor je riješio {contactName}",
          "OPEN": "Razgovor je ponovno otvorio {userName}",
          "PENDING": "Razgovor je označio kao na čekanju {userName}",
          "SNOOZED": "Razgovor je odgodio {userName}",
          "AUTO_RESOLVED": "Conversation was marked resolved by system due to {duration} days of inactivity",
          "SYSTEM_AUTO_OPEN": "Sustav je ponovno otvorio razgovor zbog pristigle nove poruke.",
          "AUTO_REOPENED": "Sustav je ponovno otvorio razgovor nakon isteka razdoblja odgode.",
          "RESOLVED_WITHOUT_CSAT": "Razgovor je označen kao riješen od strane {userName} (bez CSAT-a)",
          "AUTO_RESOLVED_INACTIVE": "Razgovor je označen kao riješen od strane sustava zbog {duration} sati neaktivnosti",
          "AUTO_RESOLVED_EMPTY": "Razgovor je označen kao riješen od strane sustava jer je bio prazan.",
          "BLOCKED_CONTACT_RESOLVED": "Sustav je riješio razgovor jer je kontakt blokiran.",
          "KAUFLAND_TICKET_CLOSED": "Sustav je riješio razgovor jer je tiket zatvoren na Kauflandu."
        },
        "PRIORITY": {
          "ADDED": "{userName} je postavio prioritet na {newPriority}",
          "UPDATED": "{userName} je promijenio prioritet s {oldPriority} na {newPriority}",
          "REMOVED": "{userName} je maknuo prioritet"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} je sam sebi dodijelio ovaj razgovor",
          "ASSIGNED": "Dodijelio {userName} korisniku {assigneeName}",
          "REMOVED": "Razgovor uklonjen s dodjele od strane {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Dodijelio {userName} timu {teamName}",
          "ASSIGNED_WITH_ASSIGNEE": "Dodijelio {userName} korisniku {assigneeName} putem tima {teamName}",
          "REMOVED": "Uklonjen iz tima {teamName} od strane {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} je dodao {labels}",
          "REMOVED": "{userName} je uklonio {labels}"
        },
        "SLA": {
          "ADDED": "{userName} je dodao SLA pravilo {slaName}",
          "REMOVED": "{userName} je uklonio SLA pravilo {slaName}",
          "UPDATED": "{userName} je ažurirao SLA pravilo {slaName}"
        },
        "MUTED": "{userName} je utišao razgovor",
        "UNMUTED": "{userName} je uključio zvuk razgovora",
        "CONTACT_BLOCKED": "{userName} je blokirao/la kontakt",
        "CONTACT_UNBLOCKED": "{userName} je odblokirao/la kontakt",
        "AUTO_RESOLUTION_MESSAGE": "Razgovor se rješava jer je bio neaktivan neko vrijeme. Započnite novi razgovor ako vam treba dodatna pomoć.",
        "DOMAIN_BLOCKED": "{userName} je blokirao sve kontakte za određenu domenu",
        "DOMAIN_UNBLOCKED": "{userName} je deblokirao sve kontakte za određenu domenu",
        "MERGED": "{userName} je spojio razgovor #{sourceId} s ovim razgovorom",
        "MOVED": "{userName} je premjestio ovaj razgovor iz pretinca {sourceInboxName} u pretinac {targetInboxName}",
        "MOVED_BY_ORDER": "Premješteno jer narudžbe kontakta dolaze samo iz trgovine {storeName} (posljednja narudžba {orderId}), čiji robot odgovara u ovom pretincu.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Radnja slanja poruke je preskočena za ovu automatsku odgovor",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatizacija je preskočena jer je kontakt blokiran",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatizacija \"{ruleName}\" nije mogla premjestiti ovaj razgovor iz sandučića {sourceInboxName} u sandučić {targetInboxName} jer sandučići nisu kompatibilni.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatizacija \"{ruleName}\" nije mogla premjestiti ovaj razgovor iz sandučića {sourceInboxName} u sandučić {targetInboxName} jer kontakt nema adresu e-pošte.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatizacija \"{ruleName}\" nije mogla poslati poruku: ovaj telefonski pretinac ne može slati SMS jer račun nema SMS pretinac. Pravilo je isključeno, a administratori su dobili e-poštu.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatizacija \"{ruleName}\" nije mogla poslati poruku: iz ovog pretinca nije moguće slati privitke putem SMS-a. Pravilo je isključeno, a administratori su dobili e-poštu.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makronaredba \"{macroName}\" nije poslala poruku: ovaj telefonski pretinac ne može slati SMS jer račun nema SMS pretinac.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makronaredba \"{macroName}\" nije poslala poruku: iz ovog pretinca nije moguće slati privitke putem SMS-a.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makronaredba \"{macroName}\" nije poslala poruku: ovaj razgovor obrađuje bot. Prvo otvorite razgovor.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makronaredba \"{macroName}\" nije poslala poruku: ovaj sandučić je označen za brisanje. Prvo premjestite razgovor u drugi sandučić.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatizacija \"{ruleName}\" poslala je e-poštu na {contactEmail} u novom razgovoru [#{conversationId}]({conversationPath}) u sandučiću {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatizacija \"{ruleName}\" pokrenula je ovaj razgovor zbog razgovora [#{conversationId}]({conversationPath}) u sandučiću {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatizacija \"{ruleName}\" nije mogla poslati poruku u novom razgovoru u sandučiću {inboxName} jer kontakt nema adresu e-pošte.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatizacija \"{ruleName}\" poslala je SMS na {contactPhone} u novom razgovoru [#{conversationId}]({conversationPath}) u sandučiću {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatizacija \"{ruleName}\" nije mogla poslati SMS u novom razgovoru u sandučiću {inboxName} jer kontakt nema telefonski broj.",
        "AUTOMATION_RULE_TRIGGERED": "Pokrenuto pravilo automatizacije \"{ruleName}\"",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Pravilo automatizacije \"{ruleName}\" je onemogućilo automatski prioritet",
        "AUTOMATION_SKIP_AUTO_LABELING": "Pravilo automatizacije \"{ruleName}\" je onemogućilo automatsko označavanje",
        "AUTOMATION_STOP_PROCESSING_RULES": "Pravilo automatizacije \"{ruleName}\" je zaustavilo daljnju obradu pravila",
        "AUTO_LABELING": {
          "REASONING": "Primijenjene oznake: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Ažurirani prioritet: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Korisnik"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Pozvani lokalni brojevi:",
          "CALL_COMPLETED": "Poziv završen",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "odgovoreno drugdje, zvonilo {duration}",
            "NO_ANSWER": "bez odgovora, zvonilo {duration}",
            "REJECTED": "odbijeno nakon zvonjenja {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operater",
            "QUEUE": "Red čekanja",
            "RING_GROUP": "Grupa zvonjenja"
          },
          "INBOUND_CALL": "Dolazni poziv s broja {number} na {did}",
          "IVR_HANDLED": "Obradio IVR",
          "IVR_LABEL_NOT_FOUND": "Htio sam dodati oznaku {name}, ali ona ne postoji. Provjerite konfiguraciju.",
          "CALL_MISSED": "Propušten poziv",
          "CALL_NO_ANSWER": "Nema odgovora",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automatski riješeno nakon neuspjelih povratnih poziva: {count}",
          "OUTBOUND_CALL": "Odlazni poziv agenta {agentName} s {did} na {number}",
          "SUMMARY_NOT_AVAILABLE": "Nije moguće izraditi sažetak.",
          "RECORDING_DELETED": "Snimka poziva izbrisana: {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Pošalji transkript razgovora",
    "DESC": "Pošaljite kopiju transkripta razgovora na navedenu adresu e-pošte",
    "SUBMIT": "Pošalji",
    "CANCEL": "Odustani",
    "SEND_EMAIL_SUCCESS": "Transkript chata uspješno je poslan",
    "SEND_EMAIL_ERROR": "Došlo je do pogreške. Pokušajte ponovno",
    "FORM": {
      "SEND_TO_CONTACT": "Pošalji transkript klijentu",
      "SEND_TO_AGENT": "Pošalji transkript dodijeljenom agentu",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Pošalji transkript na drugu adresu e-pošte",
      "EMAIL": {
        "PLACEHOLDER": "Unesite adresu e-pošte",
        "ERROR": "Unesite ispravnu adresu e-pošte"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Pozdrav 👋, dobro došli u {installationName}!",
    "DESCRIPTION": "Hvala na registraciji. Želimo da iz {installationName} izvučete najviše. Evo nekoliko stvari koje možete učiniti u {installationName}.",
    "GREETING_MORNING": "👋 Dobro jutro, {name}. Dobro došli u {installationName}.",
    "GREETING_AFTERNOON": "👋 Dobar dan, {name}. Dobro došli u {installationName}.",
    "GREETING_EVENING": "👋 Dobra večer, {name}. Dobro došli u {installationName}.",
    "READ_LATEST_UPDATES": "Pročitajte naše najnovije novosti",
    "ALL_CONVERSATION": {
      "TITLE": "Svi vaši razgovori na jednom mjestu",
      "DESCRIPTION": "Pregledajte sve razgovore s klijentima na jednoj nadzornoj ploči. Razgovore možete filtrirati prema dolaznom kanalu, oznaci i statusu.",
      "NEW_LINK": "Kliknite ovdje za izradu sandučića"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Pozovite članove tima",
      "DESCRIPTION": "Dok se pripremate za razgovor s klijentima, uključite kolege da vam pomognu. Kolege možete pozvati dodavanjem njihovih adresa e-pošte na popis agenata.",
      "NEW_LINK": "Kliknite ovdje za pozivanje člana tima"
    },
    "LABELS": {
      "TITLE": "Organizirajte razgovore pomoću oznaka",
      "DESCRIPTION": "Oznake olakšavaju kategorizaciju razgovora. Izradite oznake poput #upit-podrska, #pitanje-naplata itd. kako biste ih kasnije koristili u razgovoru.",
      "NEW_LINK": "Kliknite ovdje za izradu oznaka"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Izradite unaprijed pripremljene odgovore",
      "DESCRIPTION": "Unaprijed napisani predlošci odgovora pomažu vam da brzo odgovorite na razgovor. Agenti mogu upisati znak '/' i kratki kod za umetanje odgovora.",
      "NEW_LINK": "Kliknite ovdje za izradu unaprijed pripremljenog odgovora"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Dodijeljeni agent",
    "SELF_ASSIGN": "Dodijeli meni",
    "TEAM_LABEL": "Dodijeljeni tim",
    "SELECT": {
      "PLACEHOLDER": "Nijedan"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Prilagođeni podaci",
      "ORDER_HISTORY": "Povijest narudžbi",
      "CONTACT_DETAILS": "Podaci o kontaktu",
      "CONVERSATION_ACTIONS": "Radnje razgovora",
      "CONVERSATION_LABELS": "Oznake razgovora",
      "CONVERSATION_INFO": "Informacije o razgovoru",
      "CONTACT_ATTRIBUTES": "Atributi kontakta",
      "PREVIOUS_CONVERSATION": "Prethodni razgovori",
      "MACROS": "Makronaredbe",
      "RETINO_TICKETS": "Retino tiketi",
      "SHOPIFY_ORDERS": "Shopify narudžbe"
    },
    "SHOPIFY": {
      "ORDER_ID": "Narudžba #{id}",
      "ERROR": "Pogreška pri učitavanju narudžbi",
      "NO_SHOPIFY_ORDERS": "Nema pronađenih narudžbi",
      "FINANCIAL_STATUS": {
        "PENDING": "Na čekanju",
        "AUTHORIZED": "Autorizirano",
        "PARTIALLY_PAID": "Djelomično plaćeno",
        "PAID": "Plaćeno",
        "PARTIALLY_REFUNDED": "Djelomično refundirano",
        "REFUNDED": "Povrat izvršen",
        "VOIDED": "Poništeno"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Isporučeno",
        "PARTIALLY_FULFILLED": "Djelomično isporučeno",
        "UNFULFILLED": "Neisporučeno"
      }
    }
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Nisu pronađeni podaci",
    "LOAD_ERROR": "Nije moguće učitati podatke. Pokušajte ponovno kasnije."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Učitaj više",
    "NO_RECORDS_FOUND": "Nema pronađenih tiketa",
    "LOAD_ERROR": "Nije moguće učitati tikete iz {hookName}. Pokušajte kasnije.",
    "NOT_SEARCHABLE": "E-mail kontakta nije postavljen.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Učitavanje...",
    "NO_ORDERS": "Nema pronađenih narudžbi",
    "NOT_AVAILABLE": "Podaci o korisniku nisu dostupni",
    "EXPAND": "Otvori profil korisnika",
    "MORE_ITEMS": "+ {count} stavki",
    "EXPEDITION_STATUS": "Status otpreme",
    "OPEN_DETAIL": "otvori detalj",
    "COPY_ORDER_ID": "Broj narudžbe",
    "EXTERNAL_ID": "Vanjski ID",
    "PAYMENT_TYPE": "Način plaćanja",
    "PAYMENT_DATE": "Datum plaćanja",
    "DELIVERY_PROVIDER": "Dostavljač",
    "EXPECTED_DATE_OF_DELIVERY": "Očekivana dostava",
    "DATE_OF_DELIVERY": "Dostavljeno",
    "EXPEDITION_DATE": "Datum otpreme",
    "INTERNAL_NOTE": "Napomena trgovine",
    "PACKAGE_NUMBER": "Pošiljka"
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Izradi atribut",
    "NO_RECORDS_FOUND": "Nisu pronađeni atributi",
    "UPDATE": {
      "SUCCESS": "Atribut je uspješno ažuriran",
      "ERROR": "Nije moguće ažurirati atribut. Pokušajte ponovno kasnije"
    },
    "ADD": {
      "TITLE": "Dodaj",
      "SUCCESS": "Atribut je uspješno dodan",
      "ERROR": "Nije moguće dodati atribut. Pokušajte ponovno kasnije"
    },
    "DELETE": {
      "SUCCESS": "Atribut je uspješno izbrisan",
      "ERROR": "Nije moguće izbrisati atribut. Pokušajte ponovno kasnije"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Dodaj atribute",
      "PLACEHOLDER": "Pretraži atribute",
      "NO_RESULT": "Nisu pronađeni atributi"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Od",
    "TO": "Za",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Predmet"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Sudjelujem",
    "SIDEBAR_TITLE": "Sudionici razgovora",
    "NO_RECORDS_FOUND": "Nisu pronađeni rezultati",
    "ADD_PARTICIPANTS": "Odaberi sudionike",
    "REMANING_PARTICIPANTS_TEXT": "+{count} ostalih",
    "REMANING_PARTICIPANT_TEXT": "+{count} ostali",
    "TOTAL_PARTICIPANTS_TEXT": "Broj sudionika: {count}.",
    "TOTAL_PARTICIPANT_TEXT": "Broj sudionika: {count}.",
    "NO_PARTICIPANTS_TEXT": "Nema sudionika.",
    "WATCH_CONVERSATION": "Pridruži se razgovoru",
    "YOU_ARE_WATCHING": "Sudjelujete",
    "API": {
      "ERROR_MESSAGE": "Ažuriranje nije uspjelo. Pokušajte ponovno.",
      "SUCCESS_MESSAGE": "Sudionici su ažurirani."
    },
    "SEARCH_PLACEHOLDER": "Pretraži"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Prikaži prevedeni sadržaj",
    "DESC": "Prevedeni sadržaj možete pogledati na svakom jeziku.",
    "ORIGINAL_CONTENT": "Izvorni sadržaj",
    "TRANSLATED_CONTENT": "Prevedeni sadržaj",
    "NO_TRANSLATIONS_AVAILABLE": "Za ovaj sadržaj nema dostupnih prijevoda"
  },
  "TYPING": {
    "ONE": "{user} tipka",
    "TWO": "{user} i {secondUser} tipkaju",
    "MULTIPLE": "{user} i ostali ({count}) tipkaju",
    "IMAGE_ALT": "Netko tipka"
  },
  "READING": {
    "ONE": "{user} čita ovaj tiket",
    "TWO": "{user} i {secondUser} čitaju ovaj tiket",
    "MULTIPLE": "{user} i još {count} drugih čitaju ovaj tiket"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Isprobajte ove upite"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Premjesti razgovor",
    "DESCRIPTION": "Premjestite ovaj razgovor u drugi e-mail sandučić.",
    "SOURCE": {
      "TITLE": "Razgovor",
      "ID_LABEL": "ID razgovora"
    },
    "TARGET": {
      "TITLE": "Odredišni sandučić",
      "PLACEHOLDER": "Odaberite e-mail sandučić",
      "NO_RESULTS": "Nema drugih dostupnih e-mail sandučića",
      "ERROR": "Odaberite odredišni sandučić"
    },
    "SUBMIT": "Premjesti razgovor",
    "CANCEL": "Odustani",
    "SUCCESS_MESSAGE": "Razgovor uspješno premješten",
    "ERROR_MESSAGE": "Nije moguće premjestiti razgovor. Pokušajte ponovno."
  },
  "MERGE": {
    "TITLE": "Spoji razgovore",
    "DESCRIPTION": "Spojite ovaj razgovor s drugim razgovorom. Sve poruke iz ovog razgovora bit će premještene u ciljni razgovor, a ovaj razgovor bit će izbrisan.",
    "SOURCE": {
      "TITLE": "Izvorni razgovor (bit će izbrisan)",
      "ID_LABEL": "ID razgovora"
    },
    "TARGET": {
      "TITLE": "Ciljni razgovor",
      "PLACEHOLDER": "Unesite ID razgovora za pretraživanje (npr. 123)",
      "HELP": "Unesite ID razgovora u koji će sve poruke biti spojene.",
      "ERROR": "Odaberite ciljni razgovor"
    },
    "WARNING": "Upozorenje: Ova radnja se ne može poništiti. Sve poruke bit će premještene u ciljni razgovor, a ovaj razgovor bit će trajno izbrisan.",
    "SUBMIT": "Spoji razgovore",
    "CANCEL": "Odustani",
    "SUCCESS_MESSAGE": "Razgovor uspješno spojen",
    "ERROR_MESSAGE": "Nije moguće spojiti razgovore. Provjerite ciljni razgovor i pokušajte ponovno.",
    "SEARCH": {
      "NO_RESULTS": "Nije pronađen razgovor s ovim ID-om",
      "ERROR_MESSAGE": "Nije moguće pretraživati razgovore. Pokušajte ponovno."
    },
    "CONFIRM": {
      "TITLE": "Potvrdi spajanje",
      "DESCRIPTION": "Jeste li sigurni da želite spojiti ovaj razgovor? Ova radnja se ne može poništiti.",
      "YES": "Da, spoji",
      "CANCEL": "Odustani"
    }
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Nije moguće preuzeti privitak. Pokušajte ponovno"
  }
}
